<template>
  <a-layout class="emailfinder-layout">
    <!-- <s-header></s-header> -->
    <div class="emailfinder-index-container">
      <div class="title">
      </div>
      <p>
        小二等候多时了，输入关键词开始检索吧！
      </p>
      <div class="emailfinder-search">
        <a-select size="large" v-model="searchType">
          <a-select-option :value="1">公司名称</a-select-option>
          <a-select-option :value="2">邮箱号码</a-select-option>
        </a-select>
        <!-- <a-input @pressEnter="search" v-validate="'required|email'" v-model="email" :class="{ 'is-danger': errors.has('email') }" name="email" type="email" placeholder="请输入检索邮箱地址..." /> -->
        <a-input @pressEnter="search" size="large" v-model="searchCond" :placeholder="`请输入${searchType==1&&'公司名称'||'邮箱号码'}`" />
        <a-button type="primary" @click="search">定 位</a-button>
      </div>
      <s-banner></s-banner>
      <div class="logo"></div>
    </div>
  </a-layout>
</template>

<script>
import Header from "@/components/layout/Header";
import Banner from "@/views/account/banner";
export default {
  name: "home",
  components: {
    "s-header": Header,
    "s-banner": Banner
  },
  data() {
    return {
      searchType: 2,
      searchCond: ""
    };
  },
  computed: {
    accountInfo() {
      return this.$store.state.accountInfo;
    }
  },
  methods: {
    search() {
      var g = JSON.parse(this.$cookies.get("guest")) || [];
      if (
        !this.accountInfo &&
        g.length >= 5 &&
        !g.some(f => f == values.email)
      ) {
        return this.$loginFrm();
      }
      if (!this.searchCond) {
        this.$message.error(
          `请输入${(this.searchType == 1 && "公司名称") || "邮箱号码"}`
        );
        return;
      }

      if (
        this.searchType == 1 &&
        !!this.searchCond.match(/([\u4e00-\u9fa5])+/g)
      ) {
        return this.$message.error("请使用英文输入");
      }

      this.$router.push({
        name: "search",
        query: { search: this.searchCond, st: this.searchType }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
.emailfinder-layout {
  background-color: #fff;
  .emailfinder-index-container {
    width: 950px;
    font-size: 62.5%;
    margin: auto;
    & > p {
      font-size: 16px;
      text-align: left;
      color: #333;
    }
    .title {
      width: 328px;
      height: 110px;
      margin: 100px auto 20px;
      @include intop-icon;
      background-position: -670px 0px !important;
    }
    .logo {
      width: 150px;
      height: 40px;
      margin: 40px auto 10px;
      @include intop-icon;
      background-position: -610px -160px !important;
    }
    .emailfinder-search {
      display: flex;
      margin: 0 0 300px;
      .ant-select {
        width: 150px;
        & /deep/ .ant-select-selection {
          background-color: #ebf6ff;
        }
      }
      & /deep/ .ant-input,
      & /deep/ .ant-btn,
      & /deep/ .ant-select-selection,
      & /deep/ .ant-select-selection .ant-select-selection__rendered {
        border-radius: 0;
        height: 45px;
        line-height: 45px;
        vertical-align: middle;
      }
      & /deep/ .ant-input {
        flex: 1;
        border-left: none;
        border-right: none;
      }
      & /deep/ .ant-btn {
        width: 110px;
      }
    }
  }
}
</style>
